import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "commons/store/store";
import axiosSecureInstance from "commons/axios/axiosSecureInstance";
import { MIME_TYPE } from "utils/dataAccess";

interface ElementDataCollection {
    history: any;
}

const initialState: ElementDataCollection = {
    history: {},
};

type AddElementDataCollectionParams = {
  ecrf?: any;
  element?: any;
  elements?: Array<any>;
};

export const addElementDataCollection = createAsyncThunk(
  'elementDataCollection/add',
  async ({ ecrf, element, elements = [] }: AddElementDataCollectionParams, thunkAPI) => {
    try {
      const response = await axiosSecureInstance.post(
        `/api/element_data_collections/${ecrf}/${element}/add`,
        { elements: [...elements] },
        { headers: { Accept: MIME_TYPE, "Content-Type": MIME_TYPE } }
        );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

type UpdateElementDataCollectionParams = {
  elements?: Array<any>;
};

export const updateElementDataCollection = createAsyncThunk(
  'elementDataCollection/update',
  async ({ id, params }: { id: string, params: UpdateElementDataCollectionParams }, thunkAPI) => {
    try {
      const response = await axiosSecureInstance.put(`/api/element_data_collections/${id}`, params, {
        headers: { Accept: MIME_TYPE, "Content-Type": MIME_TYPE },
      });
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const patchElementDataCollection = createAsyncThunk(
  'elementDataCollection/patch',
  async ({ id, params }: { id: string, params: UpdateElementDataCollectionParams }, thunkAPI) => {
    try {
      const response = await axiosSecureInstance.patch(`/api/element_data_collections/${id}`, params);
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

type PostElementDataCollectionParams = {
  datas?: Array<any>;
  elements?: Array<any>;
};

export const postElementDataCollection = createAsyncThunk(
  'elementDataCollection/patch',
  async (params: PostElementDataCollectionParams, thunkAPI) => {
    try {
      const response = await axiosSecureInstance.post(`/api/element_data_collections`, params);
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const deleteElementDataCollection = createAsyncThunk(
  'elementDataCollection/delete',
  async (id: string, thunkAPI) => {
    try {
      const response = await axiosSecureInstance.delete(`/api/element_data_collections/${id}`);
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const fetchElementDataCollectionHistory = createAsyncThunk(
    'elementDataCollection/fetchHistory',
    async (id: string, thunkAPI) => {
        try {
            const response = await axiosSecureInstance.get(
                `/api/element_data_collections/${id}/histories`
            );
            return response.data;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

export const elementDataCollectionSlice = createSlice({
  name: 'elementDataCollection',
  initialState,
  reducers: {
      resetElementDataCollectionHistory(state) {
          state.history = initialState.history;
      },
  },
  extraReducers: (builder) => {
      builder.addCase(fetchElementDataCollectionHistory.fulfilled, (state, action) => {
          state.history = action.payload;
      });
  },
});

export const selectElementDataCollectionHistory = (state: RootState) => state.ecrf.elementDataCollectionSlice.history;

export const {
    resetElementDataCollectionHistory,
} = elementDataCollectionSlice.actions;

export default elementDataCollectionSlice.reducer;
